
import FontBody2 from "../../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR } from "../../../../components/fonts/font-props";
import IconWarning from "../../../../components/icons/icon-warning/icon-warning";
import { Tooltip, TOOLTIP_VARIANTS } from "../../../../components/tooltip/tooltip";
import { TOOLTIP_PLACEMENTS } from "../../../../components/tooltip/tooltip-box";
import "./wallet-payment-method-error-icon.scss";

interface IProps {
    errorText: string;
    placement?: TOOLTIP_PLACEMENTS;
}

const WalletPaymentMethodErrorIcon: React.FC<IProps> = ({ errorText, placement = TOOLTIP_PLACEMENTS.TOP }) => {
    return (
        <Tooltip content={<div className="wallet-payment-method-error-icon-tooltip-content">
            <FontBody2 color={FONT_COLOR.NEUTRAL_WHITE}>
                {errorText}
            </FontBody2>
        </div>}
            variant={TOOLTIP_VARIANTS.WARNING}
            placement={placement}
        >
            <IconWarning color="var(--color-accent-4)" />
        </Tooltip>
    );
}

export default WalletPaymentMethodErrorIcon;
